import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/format";
import { useSettings } from "@/context/SettingsContext";

export const WhatsAppFAB = () => {
  const settings = useSettings();
  const [showBalloon, setShowBalloon] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowBalloon(true), 2500);
    const t2 = setTimeout(() => setShowBalloon(false), 12000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const url = buildWhatsAppUrl(
    "Olá! 👋 Vim pelo site da HG Móveis e quero ajuda para encontrar o móvel ideal.",
    settings.whatsapp_number
  );

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end gap-2" data-testid="whatsapp-fab">
      {showBalloon && !dismissed && (
        <div
          className="relative flex items-center gap-3 bg-white rounded-2xl shadow-[0_12px_40px_-6px_rgba(0,0,0,0.25)] border border-gray-100 p-3 pr-9 max-w-[260px] sm:max-w-xs animate-in fade-in slide-in-from-bottom-2"
          data-testid="whatsapp-balloon"
        >
          <img
            src="/assets/avatar.webp"
            alt="Atendente HG"
            className="w-11 h-11 sm:w-14 sm:h-14 rounded-full object-cover object-top bg-brand-light shrink-0"
          />
          <p className="text-xs sm:text-sm text-gray-700 font-medium leading-snug">
            Olá! 👋 Posso te ajudar a encontrar o móvel ideal?
          </p>
          <button
            onClick={() => setDismissed(true)}
            className="absolute top-1.5 right-1.5 text-gray-400 hover:text-gray-600"
            aria-label="Fechar"
            data-testid="whatsapp-balloon-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        aria-label="Falar no WhatsApp"
        className="group relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-[0_8px_30px_-4px_rgba(34,197,94,0.5)] transition-all hover:scale-105 active:scale-95"
        data-testid="whatsapp-fab-button"
      >
        <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
        <img
          src="/assets/avatar.webp"
          alt=""
          className="absolute -top-2 -left-2 w-6 h-6 sm:w-7 sm:h-7 rounded-full object-cover object-top border-2 border-white bg-brand-light"
        />
      </a>
    </div>
  );
};
